import ModuleComponent from "../vue/components/ModuleComponent.vue";

// global.$ = global.jQuery = require('jquery');

//TODO to remove the library
var dt      = require( 'datatables.net-dt' );
require( 'datatables.net-fixedcolumns-dt' );



import { Filters } from './filters.js'

import { CalendarComponent } from './calendar.js'

import { SoftSorting } from './sort.js'

import {MapView} from './map-view.js'

import _ from 'lodash'

import { blissIconsetAppendSprite } from '@bliss/iconset'

import LeaderLine from 'leader-line-new';
import AnimEvent from 'anim-event';

import { Calendar } from './calendar.js'
import { Chart } from './chart.js'
import { Board } from './board.js'
import { ComponentGrid } from './component-grid.js'

import { Dataview } from './dataview.ts'
import { Dashboard } from './dashboard.js'
import { DetailsView } from './details-view.js'
import { FAQ } from './faq.js'
import { FolderView } from './folderview.js'
import { ProcessMap } from './process-map.js'
import { Module } from './module.js'
import { Stepper } from './stepper.js'
import { ViewWrapper } from './view-wrapper.js'


import { headlessModuleSessionVerify } from '../vue/lib/common'

import AOS from 'aos';

import 'slick-carousel';

// console.log('ll', ll)
// require('leader-line');


(function () {
    class App {
        /**
         * Init page scripts
         * @param {String} selector page selector
         */
        constructor(selector) {

            AOS.init();

            // console.log('LeaderLine', window.LeaderLine )

            // if ($(selector).length === 0) return

            if ( ! selector ) return;

            this.init();

            this.events()

            // this.hashLoad()

            // $(window).on('resize', _.debounce( _.bind( this.onWindowResize, this) ) )
            // $(window).on('scroll', _.bind(this.onWindowResize, this) )

            blissIconsetAppendSprite();


            // $(window).trigger('resize')
            window.dispatchEvent(new Event('resize'))

            /*
            JS migrated from bryter-publish-theme
             */
            /* go back to history */
            // $(window).on('resize', _.bind(this.onWindowResizeTheme, this) );

            // Used in the steppers component
            this.sliders();

            // $(document).on('click', '.js-go-back-history', e =>  {
            //     window.history.back()
            // })

            // this isn't used anymore but if it will be ( on steppres ) it should be implemented in the vue component
            // $(document).on('click', '.close-modal', function(e) {
            //     e.preventDefault()
            //     let $a = $(e.currentTarget),
            //         iframe_src = $a.data('module-url')

            //     if ( iframe_src && iframe_src.length ) {
            //         $('#bryter-module-1').attr('src', iframe_src)
            //     }

            //     $('body').toggleClass('ui-fullscreen-on')

            //     return false
            // })

            // commenting this out as it set to run globally anyways
            // if ( $('.steps-timeline').length ) {
            //     $(window).trigger('resize')
            // }

            // // ?? don't know if it's still used
            // $('form .cond').each( (index, element) => {

            //     let input_id = $(element).data('cond-input'),
            //         cond_value = $(element).data('cond-value')

            //     if ( $(`#${input_id}`).length ) {
            //         $(document).on('change', `#${input_id}`, (e) => {
            //             $('option:selected', e.currentTarget).val()
            //             if ( $('option:selected', e.currentTarget).val() == cond_value ) {
            //                 $(element).addClass('on')
            //             } else {
            //                 $(element).removeClass('on')
            //             }
            //             $(`#${input_id}`).triggerHandler('change')
            //         })
            //     }

            // })

            // ?? don't know if it's still used
            // $('input[type="number"]').on('keyup', function(){
            //     let v = parseInt($(this).val());
            //     let min = parseInt($(this).attr('min'));
            //     let max = parseInt($(this).attr('max'));

            //     if (v < min){
            //         $(this).val(min);
            //     } else if (v > max){
            //         $(this).val(max);
            //     }
            // })
        }

        sliders() {
            const _this = this
            // $('.home-slider').each(function(){
            //     let $slider = $(this)
            //     // console.log(_this.sliderOptions)
            //     $slider.slick( _this.sliderOptions )
            // });

            // $('#main').addClass('loaded')
            document.getElementById('main').classList.add('loaded');

            // if ( $('.stepper-tab-wrapper').length ) {

                // if ( $('.steps-timeline .step-item').length > 12 ) {

                //     $('.steps-timeline').slick({
                //         infinite: false,
                //         slidesToShow: 5,
                //         slidesToScroll: 1,
                //         fade: false,
                //         dots: false,
                //         arrows: true,
                //         centerMode: false,
                //         // autoplay: false,
                //         // speed: 1200,
                //         // autoplaySpeed: 5000,
                //         // pauseOnHover: false,
                //         rows: 0,
                //         slide: '.step-item',
                //         prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><span class="icon-Chevron-Left-Large"></span></button>',
                //         nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><span class="icon-Chevron-Right-Large"></span></button>',

                //         responsive: [
                //             {
                //                 breakpoint: 1600,
                //                 settings: {
                //                     slidesToShow: 4,
                //                     slidesToScroll: 1
                //                 }
                //             },

                //             {
                //                 breakpoint: 1480,
                //                 settings: {
                //                     slidesToShow: 3,
                //                     slidesToScroll: 1
                //                 }
                //             },
                //             {
                //                 breakpoint: 900,
                //                 settings: {
                //                     slidesToShow: 2,
                //                     slidesToScroll: 1
                //                 }
                //             },
                //             {
                //                 breakpoint: 800,
                //                 settings: {
                //                     slidesToShow: 1,
                //                     slidesToScroll: 1
                //                 }
                //             }

                //         ]
                //     })


                // }
            // } else {

                // if ( $('.steps-timeline .step-item').length > 2 ) {

                //     $('.steps-timeline').slick({
                //         infinite: false,
                //         slidesToShow: 5,
                //         slidesToScroll: 1,
                //         fade: false,
                //         dots: false,
                //         arrows: true,
                //         centerMode: false,
                //         // autoplay: false,
                //         // speed: 1200,
                //         // autoplaySpeed: 5000,
                //         // pauseOnHover: false,
                //         rows: 0,
                //         slide: '.step-item',
                //         prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><span class="icon-Chevron-Left-Large"></span></button>',
                //         nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><span class="icon-Chevron-Right-Large"></span></button>',

                //         responsive: [
                //             {
                //                 breakpoint: 1520,
                //                 settings: {
                //                     slidesToShow: 4,
                //                     slidesToScroll: 1
                //                 }
                //             },

                //             {
                //                 breakpoint: 1200,
                //                 settings: {
                //                     slidesToShow: 3,
                //                     slidesToScroll: 1
                //                 }
                //             },
                //             {
                //                 breakpoint: 900,
                //                 settings: {
                //                     slidesToShow: 2,
                //                     slidesToScroll: 1
                //                 }
                //             },
                //             {
                //                 breakpoint: 800,
                //                 settings: {
                //                     slidesToShow: 1,
                //                     slidesToScroll: 1
                //                 }
                //             }

                //         ]
                //     })
                // }
            // }

        }

        onWindowResizeTheme() {
            // if ( $('.steps-timeline').length && typeof $('.steps-timeline')[0].slick != 'undefined' )  {

            //     // console.log('st length::', $('.steps-timeline').length )

            //     $('.steps-timeline')[0].slick.refresh()
            // }
            // alert()

            let maxH = 0

            // $('.step-card').each( (i, el) => {

            //     let h = $(el).height()

            //     if ( h > maxH ) {
            //         maxH = h
            //     }
            // })

            const stepCardEls = document.getElementsByClassName('step-card')
            if ( stepCardEls ) {
                // console.log(stepCardEls)
                Array.from(stepCardEls).forEach( (item, index) => {

                    const dim = innerDimensions(item)
                    // const h = item.getBoundingClientRect().height
                    // console.log(item.getBoundingClientRect())
                    // console.log(dim)
                    const h = dim.height
                    if ( h > maxH ) {
                        maxH = h
                    }    
                })
            }
            

            // console.log('maxH', maxH)

            if ( maxH > 200 ) {

                var calHeight = ( maxH * 2 + 155 + 40 )

                const stepItemEls = document.getElementsByClassName('step-item')
                if ( stepItemEls ) {
                    Array.from(stepItemEls).forEach( item => {
                        item.style.minHeight = `{$calHeight}px`
                    }) 
                }
                const stEls = document.querySelectorAll('.slick-list .slick-track')
                if ( stEls ) {
                    // console.log(stEls)
                    Array.from(stEls).forEach(item => {
                        item.style.minHeight = `${calHeight}px`
                    })
                }

                // $('#content').css({
                //     minHeight: `${($('.subscription-head').outerHeight(true) + calHeight + 100)}px`
                // })
                const sh = document.querySelectorAll('.subscription-head')
                if ( sh ) {
                    document.getElementById('content').style.minHeight = `${(sh.offsetHeight + calHeight + 100)}px`
                }

            } else {
                // $('.content-subscription .slick-list .slick-track').css({minHeight: '680px'})
                if ( document.querySelector('.content-subscription .slick-list .slick-track') ) document.querySelector('.content-subscription .slick-list .slick-track').style.minHeight = '680px'
                // $('.step-item .card').removeAttr('style')
                if ( document.querySelectorAll('.step-item .card') ) {
                    document.querySelectorAll('.step-item .card').forEach( item => {
                        item.removeAttribute('style')
                    })
                }

                // $('#content').css({minHeight: 'calc(100vh - 48px)'});
                document.getElementById('content').style.minHeight = 'calc(100vh - 48px)'
            }

        }

        events() {

            const _this = this

            // $(document).on('click', '.toggle-view a', e => {
            //     e.preventDefault()
            //     let $a = $(e.currentTarget)

            //     $('.toggle-view a').removeClass('active')
            //     $('.vw-component').removeClass('active')
            //     // alert(( $a.index() + 1))
            //     $('.toggle-view a:nth-child(' + ( $a.index() + 1) + ')').addClass('active')
            //     $($a.attr('data-target')).css('opacity', 0).addClass('active')
            //     setTimeout(function(){
            //         // $(window).trigger('resize')
            //         window.dispatchEvent(new Event('resize'))
            //         setTimeout(function(){
            //             $($a.attr('data-target')).css('opacity', 1)
            //         }, 300)
            //     }, 500)

            //     //TODO Continue here

            // })

            // this particular event must be reimplemented in es6 if the downgraded dataview will ever be added back
            // $(document).on('click', '.inline-filter-toggle', e => {
            //     e.preventDefault()
            //     let $b = $(e.currentTarget),
            //         $parent = $b.closest('.DataTable_cell_head')
            //     $('.inline-filter-on').not($parent).removeClass('inline-filter-on')
            //     $parent.toggleClass('inline-filter-on')
            //     return false
            // })
            
            // $(document).on('click', '.stepper-step-link', e => {
            //     e.preventDefault()

            //     let $a = $(e.currentTarget),
            //         src = ''
            //     let intake_src = $a.data('iframe-src'),
            //         status_src = $a.data('status-iframe-src')

            //     if ( $('.steps').hasClass('strict-mode') && ! $a.hasClass('active') ) {
            //         return false
            //     }

            //     if ( 'intake' == $('.toggle-view-mode-wrap .active').attr('data-view-mode') ) {
            //         src = intake_src
            //     } else if ( 'status' == $('.toggle-view-mode-wrap .active').attr('data-view-mode') ) {
            //         src = status_src
            //     }

            //     $('#bryter-module-1').attr('src', src)
            //     $('.stepper-step-link').removeClass('current')
            //     $a.addClass('current')
            // })

            // moved to vue components
            // $(document).on('click', '.toggle-view-mode-wrap a', function(e){
            //     e.preventDefault()
            //     let $a = $(e.currentTarget)
            //     if ( $a.hasClass('active') ) return false;
                
            //     $('.toggle-view-mode-wrap a').removeClass('active')

            //     $a.addClass('active')

            //     $('.stepper-step-link.current').trigger('click')
                
            //     return false
            // })

            // if($('.tab-content-data_view.active').length > 0) {
            //     let activeTab = $('.tab-content-data_view.active'),
            //         addButton = activeTab.find('.top-action-button'),
            //         addButtonHref = addButton.attr('href'),
            //         url = new URL(addButtonHref);
            //
            //         url.searchParams.append('session-finished', window.location.href);
            //
            //         addButton.attr('href', url.href);
            // }

            // $(document).on('click', '.Tabs__item', function (e) {
            //     $('.Tabs__item').removeClass('Tabs__item--active')
            //     $(this).addClass('Tabs__item--active');

            //     var $tab = $(this)
            //     const id = $(this).attr('aria-controls');
            //     $('.tab-pane').removeClass('active');
            //     $('#' + id).addClass('active');

            //     if ( ! $tab.hasClass('ui-dont-close-tabs') ) {
            //         _this.closeTabIframe()
            //     }

            //     let hash = `#tab-${id}`
            //     window.location.hash = hash

            //     setTimeout( function() {
            //         window.dispatchEvent(new Event('resize'));
            //         $tab.removeClass('ui-dont-close-tabs')
            //     }, 300)
                
            // });

            // the below sequence ( event handler ) should be implemented in the FolderView if it gets migrated to Vue (you can check Stepper or ProcessMap for samples)
            // $(document).on('click', 
            //        '.ttab-content-data_view.active a:not(.download-btn):not(.top-action-button),\
            //         .ttab-content-process_map.active a:not(.download-btn),\
            //         .tab-content-folder_view.active a:not(.download-btn)'
            //         , e => {



            //     let $el = $(e.currentTarget),
            //         href = $el.attr('href'),
            //         $tab = $el.closest('.tab-pane.active'),
            //         link_target = $tab.attr('data-links-target')

            //     $('body').removeClass('iframe-is-open');
            //     $('#iframe-tab-wrapper').removeClass('active')

            //     let $iframe_wrapper =  $('.tab-content #iframe-tab-wrapper') //link_target == 'tab' ? $('.tab-pane.active #iframe-tab-wrapper') : $('.tab-pane.active #iframe-tab-wrapper')

            //     // e.preventDefault()

            //     if ( $el.attr('target') != '_blank' && ( link_target != 'window' ) && !($el.hasClass('headless-module')) ) {

            //         e.preventDefault() 

            //         let $iframe = $('iframe', $iframe_wrapper)
            //         let src = new URL(href);

            //         src.searchParams.append('embedded-layout', '1');

            //         if ( 'overlay' === link_target ) {
            //             $('body').addClass('overlay-is-active');
            //         }

            //         if ( 'right' === link_target ) {
            //             $('body').addClass('top-tab-is-active');
            //         }

            //         if ( 'split' === link_target ) {
            //             $('body').addClass('split-tab-is-active');
            //             if ( ! $('.Btn.top-action-button', $tab).length ) {
            //                 $('body').addClass('no-top-button')
            //             }
            //         }

            //         $('#context-menu').css('visibility', 'hidden')
                    
            //         $iframe.attr( 'src', src )

            //         $iframe_wrapper.append($iframe)

            //         $iframe_wrapper.addClass('active')
            //         $('body').addClass('iframe-is-open');

            //         if ( $el.attr('data-redirect') == 'close-module' ) {
            //             $('iframe', $iframe_wrapper).attr('data-session-finished', 'close')
            //         } else {
            //             $('iframe', $iframe_wrapper).attr('data-session-finished', $el.attr('data-redirect'))
            //         }


            //         return false;
            //     }
                
            // })

            // $(document).on('click', '.tab-content .Btn-close', e => {
                // e.preventDefault()

                // if ($('.tab-pane.active').length > 0) {


                //     fetch(window.location.href).then(function (response) {
                //         // The API call was successful!
                //         return response.text();
                //     }).then(function (html) {

                //         // Convert the HTML string into a document object
                //         var parser = new DOMParser();
                //         var doc = parser.parseFromString(html, 'text/html');

                //         let id = $('.tab-pane.active').attr('id');

                //         // $('#' + id + '.tab-pane.active.tab-content-data_view .DataTableWrapper').html(doc.querySelector('#' + id + '.tab-pane.active.tab-content-data_view .DataTableWrapper').innerHTML)

                //         // $('#details-main').html($(html).find('#details-main').html()) //doc.querySelector('#' + id + '.tab-pane.active.tab-content-data_view .DataTableWrapper').innerHTML)


                //         // console.log('id::', id);

                //         $('#' + id + '.tab-pane.active .DataTableWrapper').html( $(html).find('#' + id + ' .DataTableWrapper').html() )

                //         $('#' + id + '.tab-pane.active .dt-wrap').attr('class', $(html).find('#' + id + ' .dt-wrap').attr('class'))

                //         $('#' + id + '.tab-pane.active .steps-timeline .step-item').each( function() {

                //             $(this).html( $(html).find('#' + id + ' .steps-timeline .step-item').eq($(this).index()).html() )

                //             let $newEl = $(html).find('#' + id + ' .steps-timeline .step-item').eq($(this).index())
                //             if ( $newEl.hasClass('active') ) {
                //                 $(this).addClass('active') 
                //             } else {
                //                 $(this).removeClass('active') 
                //             }
                //         })

                //         if ( $('.timeline').length ) {
                //             $('.timeline').html( $(html).find('.timeline').html() ) 
                //         }

                //         $('.Tabs__item[aria-controls=' + id  + ']').addClass('ui-dont-close-tabs')

                //         $('#' + id + '.tab-pane.active .component--folder-view').html( $(html).find('#' + id + ' .component--folder-view').html() )


                //         setTimeout(function(){

                //             $('.Tabs__item[aria-controls=' + id  + ']').click()
                            
                //         }, 250)


                //         // console.log(doc.querySelector('#' + id + '.tab-pane.tab-content-data_view .DataTableWrapper'));

                //     }).catch(function (err) {
                //         // There was an error
                //         console.warn('Something went wrong.', err); 
                //     });
                // }

                // _this.closeTabIframe()
            // })

            // $(document).on('click', '.step-item > a', e => {
            //     e.preventDefault();
            // })

            // $(document).on('click', '.timeline .buttons-container a', e => {

            //     let 
            //         $iframe_wrapper = $('.tab-content #iframe-tab-wrapper'), //.length ? $('.tab-pane.active #iframe-tab-wrapper') : $('#iframe-tab-wrapper'),
            //         $iframe = $('iframe', $iframe_wrapper),
            //         $el = $(e.currentTarget),
            //         href = $el.attr('href'),
            //         src = new URL(href),
            //         link_target = $el.parent().attr('data-links-target')

            //     // console.log('$iframe_wrapper::', $iframe_wrapper)


            //     if ( link_target && 'window' != link_target ) {

            //         e.preventDefault()

            //         src.searchParams.append('embedded-layout', '1');

            //         $('body').addClass( ( link_target == 'tab' || link_target == 'right' ) ? 'top-tab-is-active' : 'overlay-is-active' );
                    
            //         $iframe.attr( 'src', src )

            //         $iframe_wrapper.append($iframe)

            //         $iframe_wrapper.addClass('active')

            //         if ( $el.attr('data-redirect') == 'close-module' ) {
            //             $('iframe', $iframe_wrapper).attr('data-session-finished', 'close')
            //         } else {
            //             $('iframe', $iframe_wrapper).attr('data-session-finished', $el.attr('data-redirect'))
            //         }

            //         return false

            //     }

            // })

            // $(document).on('click', '.stepper-tab-wrapper .step .buttons-container a', function(e) {
            //     if($('iframe[data-session-finished]').length > 0) {
            //         $('iframe[data-session-finished]').removeAttr('data-session-finished')
            //     }

            //     let $el = $(this),
            //         href = $el.attr('href'),
            //         $tab = $el.closest('.tab-content-stepper.active'),
            //         link_target = $tab.attr('data-links-target'),
            //         data_redirect = $el.data('redirect') ? $el.data('redirect') : false

            //     $('#iframe-tab-wrapper').removeClass('active')

            //     let $iframe_wrapper = $('.tab-content #iframe-tab-wrapper')// : $('.tab-pane.active #iframe-tab-wrapper')


            //     if ( $el.attr('target') != '_blank' && ( link_target == 'tab' ||  link_target == 'overlay' ||  link_target == 'right' ) ) {

            //         e.preventDefault() 

            //         let $iframe = $('iframe', $iframe_wrapper)
            //         let src = new URL(href);

            //         src.searchParams.append('embedded-layout', '1');

            //         if(link_target === 'overlay') {
            //             $('body').addClass('overlay-is-active');
            //         }

            //         if ( link_target === 'right' ) {
            //             $('body').addClass( 'top-tab-is-active' );
            //         }

            //         if ( 'split' === link_target ) {
            //             $('body').addClass('split-tab-is-active');
            //         }

                    
            //         $iframe.attr( 'src', src )

            //         $iframe_wrapper.append($iframe)

            //         $iframe_wrapper.addClass('active')

            //         if(typeof data_redirect !== 'undefined' && data_redirect !== false) {
            //             if ( $el.attr('data-redirect') == 'close-module' ) {
            //                 $('iframe', $iframe_wrapper).attr('data-session-finished', 'close')
            //             } else {
            //                 $('iframe', $iframe_wrapper).attr('data-session-finished', $el.attr('data-redirect'))
            //             }
            //         }

            //         return false;

            //     }
                
            // })


            
            // alert('x')

            $(document).on('click', '.collapse-detail-side', (e) => {
                e.preventDefault()
                const $a = $(e.currentTarget)
                $('body').toggleClass('ui-detail-side-collapsed')
                document.getElementById('lanes').dispatchEvent( new Event('scroll') )
                $(window).trigger('resize')
                return false;
            })


            $(document).on('click', '.DataTable__row[data-clickable="true"] .DataTable__cell:not(.cell-type-hyperlink):not(.cell-type-status_actions)', (e) => {
                e.preventDefault()
                let $a = $(e.currentTarget),
                    $tr = $a.parent(),
                    href = $tr.data('clickable-url')

                if ( href ) {
                    document.location.href = href
                }

                return false

            })

            $(document).on('click', '.step-card-inner[data-clickable="true"], .timeline-item[data-clickable="true"], [data-clickable="true"] .step-inner', (e) => {
                e.preventDefault()
                let $a = $(e.currentTarget),
                    href = $a.hasClass('step-inner') ? $a.parent().parent().data('clickable-url') : $a.data('clickable-url')
                if ( href ) {
                    document.location.href = href
                }

                return false

            })

            $(document).on('click', '.board-card[data-clickable="true"] .card--header, .board-card[data-clickable="true"] .card--body', (e) => {
                e.preventDefault()
                let $a = $(e.currentTarget),
                    $tr = $a.parent(),
                    href = $tr.data('clickable-url')

                if ( href ) {
                    document.location.href = href
                }

                return false

            })

            $(document).on('click', '.Popover[data-clickable="true"] .Popover__header, .Popover[data-clickable="true"] .Popover__section', (e) => {
                e.preventDefault()
                let $a = $(e.currentTarget),
                    $tr = $a.parent(),
                    href = $tr.data('clickable-url')

                if ( href ) {
                    document.location.href = href
                }

                return false

            })
            
        }

        // closeTabIframe() {
        //     let $iframe_wrapper = $('.tab-content #iframe-tab-wrapper')

        //     if ( $iframe_wrapper.length ) {
        //         let $iframe = $('iframe', $iframe_wrapper)
        //         $iframe.attr('src', '')
        //         $iframe_wrapper.removeClass('active')

        //         $('body').removeClass('iframe-is-open')
        //             .removeClass('overlay-is-active')
        //             .removeClass('top-tab-is-active')
        //             .removeClass('split-tab-is-active')
        //             .removeClass('no-top-button')
        //     }
        // }

        // hashLoad() {
        //     let hash = window.location.hash

        //     if ( '#tab-' == hash.substring(0, 5)  ) {
        //         // console.log($('.Tabs__item[aria-controls=' + hash.replace('#', '')  + ']'))
        //         setTimeout(function(){
        //             $('.Tabs__item[aria-controls=' + hash.replace('#tab-', '')  + ']').click()
        //         }, 100)
        //     }
        // }

        // headlessModuleSessionVerify(result) {
        //     // $.ajax({
        //     //     url: BRYTER.ajaxUrl,
        //     //     data: {
        //     //         action: 'headlessModuleSessionVerify',
        //     //         params: result,
        //     //         env: BRYTER.envId,
        //     //     },

        //     //     success: function( html ) {
        //     //         // console.log(html)
        //     //     }
        //     // })

        //     const data = {
        //             action: 'headlessModuleSessionVerify',
        //             params: result,
        //             env: BRYTER.envId,
        //         }
        //     await fetch(BRYTER.ajaxUrl, {
        //       method: 'POST',
        //       headers: {
        //         // 'Content-Type': 'application/json'
        //       },
        //       body: JSON.stringify(data)
        //     });
        // }

        init() {
            let that = this;
            /*
             * Run headless modules in the background when clicking on a button that has the .headless-module class
             */
            // $(document).on('click', '.headless-module', (e) => {
            //     e.preventDefault();
            //     const button = $(e.currentTarget);
            //     const params = button.attr('href');
            //     button.attr('disabled', 'disabled');
            //     $.ajax({
            //         url: BRYTER.ajaxUrl,
            //         data: {
            //             action: 'headlessModule',
            //             params: params,
            //             env: BRYTER.envId,
            //         },

            //         success: function( result ) {
            //             button.removeAttr('disabled');
            //             that.headlessModuleSessionVerify();
            //         }
            //     })
            // });

            /*
             * Check and run any unfinished headless sessions, if the session was initialized over the past month.
             */
            setTimeout(function () {
                headlessModuleSessionVerify();
            }, 3500);

            // if(($('.close-iframe-on-end').length > 0)) {
                window.addEventListener('message', bryterModuleEventListener);
            // }

            /* at the end of module go to */
            function bryterModuleEventListener(event) {

                if (event.data.type === 'bryter:module' && event.data.action === 'sessionFinished') {
                    console.log('bryter:module::sessionFinished')
                    let sessionFinishedUrl = ''


                    if ( $('iframe[data-session-finished="close"]').length ) {
                        // console.log('fff', $('iframe[data-session-finished="close"]').data('session-finished'))
                        sessionFinishedUrl = $('iframe[data-session-finished="close"]').data('session-finished')
                    } else if($('iframe[data-session-finished]').length) {
                        sessionFinishedUrl = $('iframe[data-session-finished]').data('session-finished');    
                    }

                    console.log('sessionFinishedUrl::')

                    const isEncoded = isUrlEncoded(sessionFinishedUrl);

                    if(isEncoded) {
                        sessionFinishedUrl = decodeURIComponent(sessionFinishedUrl);
                    }
                    let redirectDelay;
                    let queryString = window.location.search;
                    const urlParams = new URLSearchParams(queryString);

                    if(urlParams.get('redirect_delay')) {
                        redirectDelay = urlParams.get('redirect_delay');
                    }

                    if ( sessionFinishedUrl && 'close' == sessionFinishedUrl ) {
                        // console.log('ggg', $('iframe[data-session-finished="close"]').parent().find('.Btn-close'))
                        // $('iframe[data-session-finished="close"]').parent().find('.Btn-close').click()
                    } else if ( sessionFinishedUrl) {
                        if(redirectDelay) {
                            setTimeout(function () {
                                window.location.href = sessionFinishedUrl;
                            }, redirectDelay * 1000)
                        } else if(sessionFinishedUrl) {
                            window.location.href = sessionFinishedUrl;
                        }
                    }

                    if((urlParams.get('result_event') === 'close-module') && !($('iframe[data-session-finished="close"]').parent().find('.Btn-close')).length) {
                        if(redirectDelay) {
                            setTimeout(function () {
                                history.back(); //Go to the previous page
                            }, redirectDelay * 1000)
                        } else {
                            history.back(); //Go to the previous page
                        }
                    }
                }
            }

            /* remove iframe */
            // $(document).on("click",".remove-iframe",function() {
            //     var rem = $(this).data('remove');
            //     $("."+rem).remove();
            //     $(this).remove();
            // });

            /* open fake modal */
            //TODO remove fake modals
            // $(document).on("click",".js-open-fake-modal",function() {
            //     var src = $(this).data('href');
            //     var autoclose = $(this).data('autoclose');
            //     $('body').append('<iframe class="fake-iframe-modal" src="'+src+'"></iframe>');
            //     $('body').append('<a href="#" class="close-button remove-iframe close-button-for-fake-iframe" data-remove="fake-iframe-modal"></a>');

            //     if(autoclose == "yes")
            //         window.addEventListener('message', bryterModuleEventListener);
            // });

            //Handle search functionality
            const searchForm = document.getElementById('search-form');

            if ( searchForm ) {
                searchForm.addEventListener('submit', searchSubmit);
            }

            // $('.search-form-reset').click(function (e) {
            //     $('.search-form-input').removeClass('is-active');
            //     document.querySelector('.search-results').innerHTML = '';
            // });


            if ( $('.filters-container .dropdown-filter').length ) {
                
                let els = document.querySelectorAll('.dataview-component-vue');
                if ( ! els.length ) {
                    window.filters = new Filters( document.querySelectorAll('.filters-container .dropdown-filter') )
                }
                
            }

            // if ( ('.DataTable_cell_head .filter-menu').length || $('.search-input-form').length > 0 ) {
            if ( document.querySelector('.DataTable_cell_head .filter-menu') || document.querySelector('.search-input-form') ) {
                let els = document.querySelectorAll('.dataview-component-vue');
                if ( ! els.length ) {
                    window.filters = new Filters( document.querySelectorAll('.DataTable_cell_head .filter-menu') )
                }
            }

            // if ( $('th[data-sort]').length ) {
            if ( document.querySelectorAll('th[data-sort]') ) {
                new SoftSorting( document.querySelectorAll('th[data-sort]') )                
            }

            // This snippet should be translated into es6 if the vertical stepper gets re-enabled / migrated to vue
            // setTimeout(function(){
            //     $('.stepper-wrap--vertical .stepper-step-link.current').trigger('click')
            // }, 500)


            this.moduleInit()

            this.calendarInit()

            this.chartInit()

            this.mapViewInit()

            this.folderViewInit()

            this.vueBoardInit()

            this.vueDataviewInit()

            this.vueChartsInit()

            this.vueDetailsViewInit()

            this.vueProcessMapInit()

            this.vueStepperInit()

            this.vueComponentsGridInit()

            this.vueFaqInit()

            this.vueViewWrapperInit()

            // $('.fake-top-scroll > .fake-top-scroll-inner').width( $('.DataTableWrapper table').outerWidth( true ) )



            // this "fake-top-scroll" element wasn't migrated to the vue version
            // $('.fake-top-scroll > .fake-top-scroll-inner').width( $('.DataTableWrapper table').outerWidth( true ) )

            // $('.fake-top-scroll').scroll(function(){
            //     $('.DataTableWrapper')
            //         .scrollLeft($('.fake-top-scroll').scrollLeft());
            // });

            // $('.DataTableWrapper').scroll(function(){
            //     $('.fake-top-scroll')
            //         .scrollLeft($('.DataTableWrapper').scrollLeft());
            // });

        }

        folderViewInit() {
            let el = document.querySelectorAll('.folder-view');
            // console.log('el::', el)
            !el.length || new FolderView( el )
        }

        calendarInit() {
            let el = document.querySelectorAll('.calendar-component-vue');
            !el || new Calendar( el )

        }

        chartInit() {
            let el = document.querySelectorAll('.chart-component-container-vue');
            !el || new Chart( el )

        }

        moduleInit() {

            let el = document.querySelectorAll('.module-component-vue');
            !el || new Module( el )

        }

        mapViewInit() {
            const gc = new MapView()
            
        }

        vueBoardInit() {
            const els = document.querySelectorAll('.board-container-vue');
            !els.length || new Board( els )
        }

        vueDataviewInit() {
            const els = document.querySelectorAll('.dataview-component-vue');
            !els.length || new Dataview( els )
        }

        vueChartsInit() {
            const els = document.querySelectorAll('.dashboard-grid-container-vue');
            !els.length || new Dashboard( els )
        }

        vueDetailsViewInit() {
            const els = document.querySelectorAll('.details-view-container-vue');
            !els.length || new DetailsView( els )   
        }

        vueProcessMapInit() {
            const els = document.querySelectorAll('.component--process-map-vue');
            !els.length || new ProcessMap( els )   
        }   

        vueStepperInit() {
            const els = document.querySelectorAll('.component--stepper-vue');
            !els.length || new Stepper( els )   
        }


        vueComponentsGridInit() {
            let els = document.querySelectorAll('.component-grid-container-vue');
            !els.length || new ComponentGrid( els )
        }

        vueViewWrapperInit() {
            let els = document.querySelectorAll('.component--view-wrapper-vue');
            !els.length || new ViewWrapper( els )
        }

        vueFaqInit() {
            let els = document.querySelectorAll('.faq-component-vue');
            !els.length || new FAQ( els )
        }

        onWindowScroll(){
            // const w = $(window).width(),
            //     h = $(window).height()

            // // console.log('onWindowResize', w, h)
            // if ( $('#lanes').length ) {
            //     const l = $('#lanes .lanes--inner'),
            //         ls = $('#lanes-shadow')
            //     const obj1 = {'width': l.width(), 'height': l.height()},
            //         obj2 = l.offset()
            //     // console.log(obj1, obj2)
            //     ls.css( { ...obj1, ...obj2 })
            // }
        }

        onWindowResize() {
            // const w = $(window).width(),
            //     h = $(window).height()

            // // console.log('onWindowResize', w, h)
            // if ( $('#lanes').length ) {
            //     const l = $('#lanes'),
            //         li = $('#lanes .lanes--inner'),
            //         ls = $('#lanes-shadow')
            //     const obj1 = {'width': li.width(), 'height': l.height() < li.height() ? l.height() : li.height() },
            //         obj2 = l.offset()
            //     // console.log(obj1, obj2)
            //     ls.css( { ...obj1, ...obj2 })
            // }
            // // console.log($('#lanes--inner').offset())
        }


    }

    /**
     * Init App
     */
    window.addEventListener('DOMContentLoaded', ($) => {
        new App('body');
    });
})($);

function searchSubmit(event) {

    event.preventDefault();

    const val = document.getElementById('search').value;
    if(val) {
        $('.search-form-input').addClass('is-active');
    } else {
        $('.search-form-input').removeClass('is-active');
    }
    //https://wizard-sso.localhost/virtual-legal-department/wp-json/bryter-publish/v1/bryter-vle/?search=nda

    document.querySelector('.search-results').innerHTML = '';
    if(val) {
        const url = encodeURI(BRYTER.homeUrl + '/wp-json/bryter-publish/v1/all?search=' + val);

        // console.log(url);

        fetch(url)
            .then(response => response.json())
            .then(html => {

                document.querySelector('.search-results').insertAdjacentHTML('afterbegin', html);
            }).catch(error => {
            console.log(error);
        });
    }
}

function isUrlEncoded(url) {
    try {
        const decodedUrl = decodeURIComponent(url);
        // If the decoded URL is different from the original URL, it's encoded.
        return decodedUrl !== url;
    } catch (error) {
        // If an error occurs during decoding, it's likely an invalid encoded URL.
        return false;
    }
}


export const innerDimensions = (node) => {
  var computedStyle = getComputedStyle(node)

  let width = node.clientWidth // width with padding
  let height = node.clientHeight // height with padding

  height -= parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom)
  width -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight)
  return { height, width }
}